import React, { useState } from "react";
import videoBg from "../Assest/video.mp4";
import CountUp from "react-countup";
import Footer from "./Footer";
import styled, { keyframes } from "styled-components";
import Marquee from "react-fast-marquee";
import Testi from "./Testi";
import Aluminis from "./Alumini";
import Events from "./Events";

const Main = () => {
  return (
    <div>
      {/* This is the Video playing and the nav bar section  */}
      <div className="main">
        <div>
          <div className="overlay"></div>
          <video src={videoBg} autoPlay muted loop />

          {/* <div className="video-content">
            <p>
              A Place for Learning, Discovery, Innovation, Expression and
              Discourse.
            </p>
            <button
              style={{
                marginTop: "40px",
                backgroundColor: "#0c4da2",
                padding: ".7rem",
                color: "white",
                width: "20%",
                alignItems: "center",
                marginLeft: "5%",
                borderRadius: ".3rem",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              Explore The New College ➔
            </button>
          </div> */}
        </div>
        {/* <div className="second-part">
          <h2>
            Accredited by NAAC with 'A++' Grade(Affiliated to University of
            Madras)
          </h2>
          <img
            className="image"
            src="https://thenewcollege.edu.in/images/homegallery/IMG_0008.png"
            alt="College Enterence"
          />
          <div className="lab">
            <h1>The New College</h1>
          </div>
        </div> */}

        {/* <div className="circular-part">
          <div className="circular-area">
            <h2>Circular</h2>

            <marquee
              behavior="scroll"
              direction="up"
              onmousedown="this.stop();"
              onmouseup="this.start();"
            >
              <div className="circular-area-inside">
                <div className="circular-date">
                  <h3>28</h3>
                  <h3> Nov, 2024</h3>
                </div>
                <p>MEASI Scholarship Application Form</p>
                <a
                  className="circular-link"
                  href="https://thenewcollege.edu.in/pdf/popupnews/20241129044702MEASI%20FRESH%20&%20RENEVAL%20FORM%20-%202024%20-%202025....pdf"
                  target="new"
                >
                  READ MORE
                </a>
              </div>
              <div className="circular-area-inside">
                <div className="circular-date">
                  <h3>28</h3>
                  <h3> Nov, 2024</h3>
                </div>
                <p>MEASI SCHOLARSHIP 2024 - 2025 CIRCULAR</p>
                <a
                  className="circular-link"
                  href="https://thenewcollege.edu.in/pdf/circular/20241129044605MEASI%20SCHOLARSHIP%202024%20-%202025%20CIRCULAR.pdf"
                  target="new"
                >
                  READ MORE
                </a>
              </div>
              <div className="circular-area-inside">
                <div className="circular-date">
                  <h3>28</h3>
                  <h3> Nov, 2024</h3>
                </div>
                <p>
                  A 2 day International Seminar on Achievements, Challenges &
                  Revitalization Opportunities for MSMEs sector in Vision Viksit
                  Bharat @2047 sponsored by ICSSR on 18th & 19th February 2025.
                </p>
                <a
                  className="circular-link"
                  href="https://thenewcollege.edu.in/pdf/circular/20241118091410MSME.pdf"
                  target="new"
                >
                  READ MORE
                </a>
              </div>
            </marquee>
          </div>

          <div className="circular-area">
            <h2>Events</h2>
            <marquee
              behavior="scroll"
              direction="up"
              onmousedown="this.stop();"
              onmouseup="this.start();"
            >
              <div className="circular-area-inside">
                <div className="circular-date">
                  <h3>18</h3>
                  <h3> Nov, 2024</h3>
                </div>
                <p>
                  A 2 day International Seminar on Achievements, Challenges &
                  Revitalization Opportunities for MSMEs sector in Vision Viksit
                  Bharat @2047 sponsored by ICSSR on 18th & 19th February 2025.
                </p>
                <a
                  className="circular-link"
                  href="https://thenewcollege.edu.in/pdf/eventshome/20241118091605MSME.pdf"
                  target="new"
                >
                  READ MORE
                </a>
              </div>
              <div className="circular-area-inside">
                <div className="circular-date">
                  <h3>18</h3>
                  <h3> Nov, 2024</h3>
                </div>
                <p>
                  A 2 day International Seminar on Achievements, Challenges &
                  Revitalization Opportunities for MSMEs sector in Vision Viksit
                  Bharat @2047 sponsored by ICSSR on 18th & 19th February 2025.
                </p>
                <a
                  className="circular-link"
                  href="https://thenewcollege.edu.in/pdf/eventshome/20241118091605MSME.pdf"
                  target="new"
                >
                  READ MORE
                </a>
              </div>
            </marquee>
          </div>

          <div className="circular-area">
            <h2>Academic Calendar 2024-2025</h2>
            <div className="circular-area-inside">
              <div className="circular-date">
                <h3>09</h3>
                <h3>May 2025</h3>
              </div>
              <p>Publication of April 2025 ESE Results</p>
            </div>
            <div className="circular-area-inside">
              <div className="circular-date">
                <h3>28</h3>
                <h3> Nov, 2024</h3>
              </div>
              <p>MEASI SCHOLARSHIP 2024 - 2025 CIRCULAR</p>
              <a
                className="circular-link"
                href="https://thenewcollege.edu.in/pdf/circular/20241129044605MEASI%20SCHOLARSHIP%202024%20-%202025%20CIRCULAR.pdf"
                target="new"
              >
                READ MORE
              </a>
            </div>
            <div className="circular-area-inside">
              <div className="circular-date">
                <h3>28</h3>
                <h3> Nov, 2024</h3>
              </div>
              <p>
                A 2 day International Seminar on Achievements, Challenges &
                Revitalization Opportunities for MSMEs sector in Vision Viksit
                Bharat @2047 sponsored by ICSSR on 18th & 19th February 2025.
              </p>
              <a
                className="circular-link"
                href="https://thenewcollege.edu.in/pdf/circular/20241118091410MSME.pdf"
                target="new"
              >
                READ MORE
              </a>
            </div>
          </div>
        </div> */}

        <div className="flex flex-row items-center justify-center flex-wrap gap-x-40 mb-20">
          <div className="flex flex-col items-center justify-center mt-10 rounded-lg shadow-2xl p-5 h-96">
            <h1 className="text-2xl font-bold text-black mb-5">
              {" "}
              Academic Calender
            </h1>
            <marquee behavior="scroll" direction="up">
              <Events />
            </marquee>
          </div>
          <div className="flex flex-col items-center justify-center mt-10 rounded-lg shadow-2xl p-5 h-96">
            <h1 className="text-2xl font-bold text-black mb-5">
              Announcements
            </h1>
            <marquee behavior="scroll" direction="up">
              <Events />
            </marquee>
          </div>
        </div>

        {/* This is the auto Counter Section of the page... */}
        <div className="main-counter">
          <div className="first-layer">
            <div className="ugs">
              <h1 className=" font-bold">
                <CountUp start={0} end={30} duration={8} delay={3} />
              </h1>
              <p className="font-bold">U.G Courses</p>
            </div>
            <div className="ug">
              <h1 className="font-bold">
                <CountUp start={0} end={16} duration={8} delay={3} />
              </h1>
              <p className="font-bold">P.G Courses</p>
            </div>
            <div className="ug">
              <h1 className="font-bold">
                <CountUp start={0} end={8} duration={8} delay={3} />
              </h1>
              <p className="font-bold">M.Phil Courses</p>
            </div>
            <div className="ug">
              <h1 className="font-bold">
                <CountUp start={0} end={10} duration={8} delay={3} />
              </h1>
              <p className="font-bold">Ph.D Courses</p>
            </div>
            <div className="ug">
              <h1 className="font-bold">
                <CountUp start={0} end={129281} duration={5} delay={3} />
              </h1>
              <p className="font-bold">Library Books</p>
            </div>
          </div>

          <div className="space">
            <div></div>
          </div>

          <div className="first-layer">
            <div className="ugs">
              <h1 className="font-bold">
                <CountUp start={0} end={148} duration={8} delay={3} />
              </h1>
              <p className="font-bold">Library Journals</p>
            </div>
            <div className="ug">
              <h1 className="font-bold">
                <CountUp start={0} end={1518} duration={5} delay={3} />
              </h1>
              <p className="font-bold">Competitive Exam Books</p>
            </div>
            <div className="ug">
              <h1 className="font-bold">
                <CountUp start={0} end={24143} duration={5} delay={3} />
              </h1>
              <p className="font-bold">Book Banks</p>
            </div>
          </div>

          <div className="space">
            <div></div>
          </div>

          <div className="first-layer">
            <div className="ugs">
              <h1 className="font-bold">
                <CountUp start={0} end={10} duration={8} delay={3} />
              </h1>
              <p className="font-bold">Research Departments</p>
            </div>
            <div className="ug">
              <h1 className="font-bold">
                <CountUp start={0} end={38} duration={8} delay={3} />
              </h1>
              <p className="font-bold">Research Guides</p>
            </div>
          </div>

          <div className="space">
            <div></div>
          </div>
          <button className="explore">Explore The New College ➔</button>

          <div className="space">
            <div></div>
          </div>
        </div>
        {/* This is the Recent Activities part */}
        <div className="activities">
          {/* This is the college fac page */}

          <div className="about">
            <h3 className=" text-lg font-bold">About Us</h3>
            <p>
              The New College is a government-aided, Autonomous, Arts and
              Science college affiliated to the University of Madras. It was
              established in 1951 by the Muslim Association of Southern India
              (MEASI). The college is re-accredited by NAAC with A++ (CGPA 3.61
              out of 4) in the fourth cycle. The college envisions to promote
              educational and economic equity by helping aspiring and
              underprivileged youth gain access to quality education and to
              nurture them into successful model citizens of the country. The
              vision is implemented through a 5E holistic development approach
              that strives to elevate, educate, empower, engage the students and
              enable them to excel in life and career. The institution considers
              Inclusivity, Student Centredness, Excellence and Leadership
              Development as its core values. The college offers 27 UG and 15 PG
              programmes across arts, science and commerce disciplines. Research
              leading to the award of Ph.D. is offered in 11 departments of the
              college. Currently, the college has 313 faculty members and over
              6100 students are pursuing higher education in the college. The
              college has established state-of-the art laboratories, ICT enabled
              classrooms, seminar Halls, multipurpose auditorium, central
              library, hostel and sports and games facilities.{" "}
            </p>

            <button className="explore">More Details ➔</button>
          </div>

          {/* <div class="container">
            <div class="box">
              <div class="imgBox">
                <img
                  src="https://thenewcollege.edu.in/images/chairman.jpg"
                  alt=""
                />
              </div>
              <div class="content">
                <h2>
                  Janab Imthiaz Pasha <br></br>
                  <span>Chairman</span>
                </h2>
              </div>
            </div>
            <div class="box">
              <div class="imgBox">
                <img
                  src="https://thenewcollege.edu.in/images/secretary.jpg"
                  alt=""
                />
              </div>
              <div class="content">
                <h2>
                  Janab. ELIAS SAIT <br></br>
                  <span>Secretary & Correspondent</span>
                </h2>
              </div>
            </div>
            <div class="box">
              <div class="imgBox">
                <img
                  src="https://thenewcollege.edu.in/images/treasurer.jpg"
                  alt=""
                />
              </div>
              <div class="content">
                <h2>
                  Mr. S.M.A. Mohammed Saleem<br></br>
                  <span>Hony. Treasurer</span>
                </h2>
              </div>
            </div>
            <div class="box">
              <div class="imgBox">
                <img
                  src="https://thenewcollege.edu.in/images/principal.jpg"
                  alt=""
                />
              </div>
              <div class="content">
                <h2>
                  Dr. M. Asrar Sheriff<br></br>
                  <span>PRINCIPAL</span>
                </h2>
              </div>
            </div>
          </div> */}

          <Testi />

          <h1 className="font-bold text-3xl">Recent Activities</h1>

          <div className="flex flex-row flex-wrap">
            <div className="main-activity-container gap-x-20">
              <div className="activity-container">
                <div className="image-container">
                  <img
                    src="https://thenewcollege.edu.in/images/recent/20240305051902IMG-20240303-WA0026.jpg"
                    alt=""
                  />
                </div>
                <div className="data-container">
                  <p>72nd Annual Sports Day</p>
                </div>
              </div>

              <div className="activity-container">
                <div className="image-container">
                  <img
                    src="https://thenewcollege.edu.in/images/recent/2024030505022905d146949be747b3bbd5e30d399b9ca8.jpg"
                    alt=""
                  />
                </div>
                <div className="data-container">
                  <p>International Seminar</p>
                </div>
              </div>

              <div className="activity-container">
                <div className="image-container">
                  <img
                    src="https://thenewcollege.edu.in/images/recent/20240229044642Urdu%20Programme.jpg"
                    alt=""
                  />
                </div>
                <div className="data-container">
                  <p>Urdu Day and Mushaira</p>
                </div>
              </div>

              <div className="activity-container">
                <div className="image-container">
                  <img
                    src="https://thenewcollege.edu.in/images/recent/20240228150856WhatsApp%20Image%202024-02-28%20at%2020.38.11_56a0f410.jpg"
                    alt=""
                  />
                </div>
                <div className="data-container">
                  <p>IRAC 2K24</p>
                </div>
              </div>
            </div>
          </div>

          <button className="explore">View All Activities ➔</button>
          <div className="space">
            <div></div>
          </div>
        </div>

        {/* This is our Alumini page  */}
        <Aluminis />
        
        {/* This is the Digital Initiatives Part */}
        <div className="digital">
          <h1 className="font-bold text-3xl">Digital Initiatives</h1>

          <div className="flex flex-wrap flex-row items-center justify-center">
            <img
              src="https://thenewcollege.edu.in/images/logo-1.jpg"
              className="h-36 w-60"
              alt=""
            />
            <img
              src="https://thenewcollege.edu.in/images/logo-1.jpg"
              className="h-36 w-60"
              alt=""
            />
            <img
              src="https://thenewcollege.edu.in/images/logo-1.jpg"
              className="h-36 w-60"
              alt=""
            />
            <img
              src="https://thenewcollege.edu.in/images/logo-1.jpg"
              className="h-36 w-60"
              alt=""
            />
          </div>
          <button className="explore">View All Digital Initiatives ➔</button>
          <div className="space">
            <div></div>
          </div>
        </div>
        {/* This is the Our Gallery part */}
        <div className="gallery">
          <h1 className="font-bold text-3xl">Our Gallery</h1>

          <div className="flex flex-row flex-wrap items-center justify-center gap-x-14 mb-16 mt-10">
            <img
              src="https://thenewcollege.edu.in/images/homegallery/SIP%202024-25%20Poster.jpg"
              alt=""
              className=" h-96 w-60 rounded"
              style={{ objectFit: "cover" }}
            />
            <img
              src="https://thenewcollege.edu.in/images/homegallery/SIP%202024-25%20Poster.jpg"
              alt=""
              className=" h-96 w-60 rounded"
              style={{ objectFit: "cover" }}
            />
            <img
              src="https://thenewcollege.edu.in/images/homegallery/SIP%202024-25%20Poster.jpg"
              alt=""
              className=" h-96 w-60 rounded"
              style={{ objectFit: "cover" }}
            />
            <img
              src="https://thenewcollege.edu.in/images/homegallery/SIP%202024-25%20Poster.jpg"
              alt=""
              className=" h-96 w-60 rounded"
              style={{ objectFit: "cover" }}
            />
          </div>
          <button className="explore">View All Our Gallery ➔</button>
          <div className="space">
            <div></div>
          </div>
        </div>
        {/* This is the OUR RECRUITERS Marquee Section */}
        <div className="our">
          <h1 className="font-bold text-3xl">OUR RECRUITERS</h1>

          <div>
            <Marquee>
              <div className="flex flex-row mt-10">
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-10.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-4.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-5.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-7.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-8.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-9.jpg"
                  alt=""
                />

                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-13.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-11.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-16.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-18.jpg"
                  alt=""
                />
                <img
                  src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2024/09/SRMIST-Startup-Ecosystem-5.jpg"
                  alt=""
                />
              </div>
            </Marquee>
          </div>
          <div className="space">
            <div></div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Main;
